const CLAWSON_SET_READY = 'clawson-set-ready';
const CLAWSON_SET_LOADING = 'clawson-set-loading';

export const initialState = {
  loading: true,
  ready: false
};

export default function reduce(state, action) {
  switch (action.type) {
    case CLAWSON_SET_READY:
      return {
        ...state,
        ready: action.value
      };
    case CLAWSON_SET_LOADING:
      return {
        ...state,
        loading: action.value
      };
    default:
      throw new Error(`Unknown action ${action.type}`);
  }
}

export function setReady(bot) {
  return {
    type: CLAWSON_SET_READY,
    value: bot
  };
}

export function setLoading(value) {
  return {
    type: CLAWSON_SET_LOADING,
    value
  };
}
